"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCopyToClipboard = void 0;
const react_1 = require("react");
const copy_to_clipboard_1 = __importDefault(require("copy-to-clipboard"));
const utils_1 = require("@icr-ui/utils");
const use_mounted_state_1 = require("./use-mounted-state");
const use_set_state_1 = require("./use-set-state");
const useCopyToClipboard = () => {
    const isMounted = (0, use_mounted_state_1.useMountedState)();
    const [state, setState] = (0, use_set_state_1.useSetState)({
        value: undefined,
        error: undefined,
        noUserInteraction: true,
    });
    const copyToClipboard = (0, react_1.useCallback)((value) => {
        if (!isMounted()) {
            return;
        }
        let noUserInteraction;
        let normalizedValue;
        try {
            // only strings and numbers casted to strings can be copied to clipboard
            if (typeof value !== 'string' && typeof value !== 'number') {
                const error = new Error(`Cannot copy typeof ${typeof value} to clipboard, must be a string`);
                if (utils_1.__DEV__)
                    console.error(error);
                setState({
                    value,
                    error,
                    noUserInteraction: true,
                });
                return;
            }
            // empty strings are also considered invalid
            else if (value === '') {
                const error = new Error(`Cannot copy empty string to clipboard.`);
                if (process.env.NODE_ENV === 'development')
                    console.error(error);
                setState({
                    value,
                    error,
                    noUserInteraction: true,
                });
                return;
            }
            normalizedValue = value.toString();
            noUserInteraction = (0, copy_to_clipboard_1.default)(normalizedValue);
            setState({
                value: normalizedValue,
                error: undefined,
                noUserInteraction,
            });
        }
        catch (error) {
            setState({
                value: normalizedValue,
                error: error,
                noUserInteraction,
            });
        }
    }, [isMounted, setState]);
    return [state, copyToClipboard];
};
exports.useCopyToClipboard = useCopyToClipboard;
//# sourceMappingURL=use-copy-to-clipboard.js.map